export const CHAT_CONVERSATION_ATTACHMENT_UPLOAD_REQUEST =
  'chat/conversation-attachment-upload-request'
export const CHAT_CONVERSATION_ATTACHMENT_UPLOAD_SUCCESS =
  'chat/conversation-attachment-upload-success'
export const CHAT_CONVERSATION_ATTACHMENT_UPLOAD_FAILED =
  'chat/conversation-attachment-upload-failed'
